import type { ApplePayConfig, DepositAmountsConfig, DepositPaymentMethods, PaymentsFlags, WithdrawPaymentMethods } from '../../paymentMethods.types';

const DEPOSIT_PAYMENT_METHODS = {
  APPLE_PAY: {
    name: 'Apple Pay',
    'data-track-method': 'Apple Pay',
    'data-track-provider': 'Worldpay',
    apiName: 'WORLDPAY_APPLEPAY',
    minAllowedAmount: 100,
    maxAllowedAmount: 2000000,
  },
  CARD: {
    name: 'Debit card',
    'data-track-method': 'Debit Card',
    'data-track-provider': 'Worldpay',
    apiName: 'worldpaycard',
    minAllowedAmount: 100,
    maxAllowedAmount: 2000000,
    label: 'Card',
  },
} satisfies Pick<DepositPaymentMethods, 'APPLE_PAY' | 'CARD'>;

const WITHDRAW_PAYMENT_METHODS = {
  BANK_TRANSFER: {
    name: 'Bank transfer',
    'data-track-method': 'Bank Transfer',
    apiName: 'bank_transfer',
  },
} satisfies WithdrawPaymentMethods;

const paymentMethodsConfig = {
  depositMethods: DEPOSIT_PAYMENT_METHODS,
  withdrawMethods: WITHDRAW_PAYMENT_METHODS,
};

const PAYMENTS_FLAGS = {
  showDepositLimitButtonOnDepositAmountStep: false,
  acceptsAmexCards: true,
  requiresFirstTimeDepositTermsAcceptance: false,
} satisfies PaymentsFlags;

const DEPOSIT_AMOUNTS = {
  defaultAmount: 10_00,
  quickAmounts: [10_00, 25_00, 50_00],
} satisfies DepositAmountsConfig;

const APPLE_PAY_CONFIG: ApplePayConfig = {
  playerCountry: 'AU',
  merchantLabel: 'KenoGO',
};

export { APPLE_PAY_CONFIG, DEPOSIT_AMOUNTS, paymentMethodsConfig, PAYMENTS_FLAGS };
